<template>
  <div class="vd-gl-content">
    <div>
      <a-icon type="info-circle" style="color: #40a9ff" />
      请先
      <span style="color: #ff6363">上传数据表格</span>
      后再来配置自定义规则。 配置自定义规则后，生成推广二维码进行推广。
    </div>
    <a-row class="vd-toolbar">
      <a-col class="vd-toolbar-right vd-bar">
        <a-form layout="inline">
          <a-form-item>
            <a-input
              class="vd-input-xs"
              placeholder="名称"
              v-model="searchForm.name"
              type="text"
            />
          </a-form-item>
          <a-form-item>
            <a-select
              style="width: 156px"
              v-model="searchForm.category"
              placeholder="请选择项目类型"
              allowClear
            >
              <a-select-option v-for="item in subList" :key="item.id">
                {{ item.nickname }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" icon="search" @click="search" />
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              icon="plus"
              @click="toModifyPage(null, null)"
            >
              新建
            </a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <a-table row-key="id" :pagination="pagination" :data-source="list">
      <a-table-column align="center" title="ID" data-index="id" />
      <a-table-column title="名称" data-index="name" />
      <a-table-column title="项目名称" data-index="category_name" />
      <a-table-column align="center" title="头图" data-index="head_pic">
        <template slot-scope="item">
          <img :src="item" alt="" style="width: 200px;" />
        </template>
      </a-table-column>
      <a-table-column title="背景图" data-index="background_pic">
        <template slot-scope="item">
          <a-tooltip>
            <template slot="title">
              <img :src="item" style="width: 160px;" />
            </template>
            <img :src="item" style="width: 50px;" />
          </a-tooltip>
        </template>
      </a-table-column>
      <a-table-column title="创建时间" data-index="add_time">
        <template slot-scope="item">
          {{ $FormatUtil.timestamp2date(item) }}
        </template>
      </a-table-column>
      <a-table-column title="操作" align="center">
        <template slot-scope="item">
          <template v-if="$AuthUtil.authRoute('/auto/modify')">
            <a-tooltip title="修改" @click="toModifyPage(item.id, item.name)">
              <a-icon class="common-icon" type="setting" />
            </a-tooltip>
          </template>

          <template v-if="$AuthUtil.authRoute('/auto/member')">
            <a-tooltip
              title="添加推广用户"
              @click="toMemberPage(item.id, item.name)"
            >
              <a-icon class="common-icon" type="user-add" />
            </a-tooltip>
          </template>

          <template v-if="$AuthUtil.authRoute('/auto/member/list')">
            <a-tooltip
              title="推广员列表"
              @click="toMemberListPage(item.id, item.name)"
            >
              <a-icon class="common-icon" type="qrcode" />
            </a-tooltip>
          </template>

          <template v-if="$AuthUtil.authRoute('/auto/collection')">
            <a-tooltip
              title="查看收集数据"
              @click="toDataPage(item.id, item.name)"
            >
              <a-icon class="common-icon" type="database" />
            </a-tooltip>
          </template>
          <template v-if="$AuthUtil.authRoute('/auto/linked')">
            <a-tooltip
              title="查看关联数据表"
              @click="toBindData(item.table_id)"
            >
              <a-icon class="common-icon" type="link" />
            </a-tooltip>
          </template>
        </template>
      </a-table-column>
    </a-table>
  </div>
</template>

<script>
import { get_sub } from '@/api'
import { auto_get_program } from '@/api/auto'
export default {
  name: 'Rule',
  data() {
    return {
      list: [],
      subList: [],
      searchForm: {
        name: undefined,
        category: undefined,
      },
      pagination: {
        total: 1,
        current: 1,
        pageSize: 10,
        hideOnSinglePage: true,
        onChange: (page) => {
          this.pagination.current = page
        },
      },
    }
  },
  created() {
    this.getData()
    // 获取 category 类型
    get_sub('item_type').then((res) => {
      if (res.code === 1) {
        this.subList = res.list
      } else {
        this.$message.warning(res.msg)
      }
    })
  },
  methods: {
    toModifyPage(id, name) {
      this.$router.push({
        path: '/auto/modify',
        query: { id, name },
      })
    },
    toMemberPage(id, name) {
      this.$router.push({
        path: '/auto/member',
        query: {
          id: id,
          name: name,
        },
      })
    },
    toMemberListPage(id, name) {
      this.$router.push({
        path: '/auto/member/list',
        query: {
          id: id,
          name: name,
        },
      })
    },
    toDataPage(id, name) {
      this.$router.push({
        path: '/auto/collection',
        query: {
          id: id,
          name: name,
        },
      })
    },
    toBindData(table_id) {
      this.$router.push({
        path: '/auto/table/data',
        query: {
          id: table_id,
        },
      })
    },
    getData() {
      auto_get_program({
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
        category: this.searchForm.category,
        name: this.searchForm.name,
      }).then((res) => {
        if (res.code === 1) {
          this.list = res.list
          this.pagination.total = res.total
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    search() {
      this.pagination.total = 0
      this.pagination.current = 1
      this.getData()
    },
  },
}
</script>

<style scoped></style>
